import { Divider, Stack, Text } from '@mantine/core';
import { IconCircleDashedCheck as SuccessIcon } from '@tabler/icons-react';
import { useState } from 'react';
import { useTranslation } from 'react-i18next';

import { AlreadyImported } from '@/module/Sync/components/AlreadyImported';
import { SyncItem } from '@/module/Sync/components/SyncItem';
import { ImportResult } from '@/module/Sync/model/SyncTypes';

import { NoContentPlaceholder } from '@/core/components';

interface SyncProps {
  result: ImportResult;
  sourceType: string;
}

export function Sync({ result, sourceType }: SyncProps) {
  const { list } = result;
  const { t } = useTranslation();
  const alreadyImported = list.filter(it => it.state === 'IMPORTED');
  const other = list.filter(it => it.state !== 'IMPORTED');

  const [currentIndex, setCurrentIndex] = useState(0);
  const next = () => setCurrentIndex(prev => prev + 1);

  const onAdd = () => {
    next();
  };

  if (list.length === 0) {
    return <NoContentPlaceholder title={t('sync.noContentForSelectedYear')} />;
  }

  if (other.length === 0 || currentIndex === other.length) {
    return (
      <Stack>
        <NoContentPlaceholder
          title={t('sync.completed')}
          actions={
            <SuccessIcon
              color="green"
              size="60px"
              stroke="2"
            />
          }
        />
        {alreadyImported.length > 0 && <AlreadyImported list={alreadyImported} />}
      </Stack>
    );
  }

  const { state, item, publication } = other[currentIndex];

  return (
    <Stack>
      {alreadyImported.length > 0 && <AlreadyImported list={alreadyImported} />}
      <Divider />
      <Text fw="500">{t('sync.importProcessing', { current: currentIndex + 1, total: other.length })}</Text>
      <SyncItem
        key={item.title}
        publication={publication}
        sourceType={sourceType}
        item={item}
        state={state}
        next={next}
        onAdd={onAdd}
      />
    </Stack>
  );
}
